import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from 'hooks/useRefreshToken';
import useAuth from 'hooks/useAuth';
import jwtDecode from "jwt-decode";
import Spinner from "./utils/Spinner";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, setAuth, persist } = useAuth();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                const refreshResult = await refresh();
                const decodedRes : any = jwtDecode(refreshResult)
                const accessToken = refreshResult;
                const email = decodedRes.email;
                const isAdmin = decodedRes.isAdmin;
                const name = decodedRes.name;
                const id = decodedRes.sub;
                setAuth({accessToken, email,isAdmin,name,id})
            }
            catch (err) {
                console.error(err);
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        !auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);

        return () => {isMounted = false};
    }, [])

    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? <div className="min-h-screen grid place-content-center">
                        <Spinner twWidthHeight="w-32 h-32"></Spinner>
                    </div>
                    : <Outlet />
            }
        </>
    )
}

export default PersistLogin